import React from "react";
import classNames from "classnames";
import ModalShell from "./ModalShell";
import { CheckMark } from "../_shared/icons";
import { WIDGET_META, WidgetKey, WidgetMeta } from "../data";
import styles from "./CustomizeWidgetsModal.module.scss";

interface CustomizeWidgetsModalProps {
  show: Record<WidgetKey, boolean>;
  onToggle: (key: WidgetKey) => void;
  onReset: () => void;
  onClose: () => void;
  /** widget catalogue override for campus-scoped reuse (defaults to head office) */
  widgets?: WidgetMeta[];
}

export default function CustomizeWidgetsModal({
  show,
  onToggle,
  onReset,
  onClose,
  widgets = WIDGET_META,
}: CustomizeWidgetsModalProps) {
  // The first 5 widgets of every dashboard are fixed (always on) and not listed
  // here — only the remaining ones are offered as toggleable options.
  const FIXED_COUNT = 5;
  const toggleable = widgets.slice(FIXED_COUNT);
  const activeCount = toggleable.filter((m) => show[m.key]).length;

  const renderItem = (m: WidgetMeta) => {
    const on = show[m.key];
    return (
      <button
        type="button"
        key={m.key}
        className={styles.item}
        onClick={() => onToggle(m.key)}
      >
        <span className={classNames(styles.box, on && styles.boxOn)}>
          {on && <CheckMark />}
        </span>
        <span className={styles.itemLabel}>{m.label}</span>
        <span className={styles.itemHint}>{m.hint}</span>
      </button>
    );
  };

  const footer = (
    <>
      <button type="button" className={styles.resetBtn} onClick={onReset}>
        Reset to default
      </button>
      <div className={styles.footRight}>
        <span className={styles.footCount}>
          {activeCount} of {toggleable.length} shown
        </span>
        <button type="button" className={styles.doneBtn} onClick={onClose}>
          Done
        </button>
      </div>
    </>
  );

  return (
    <ModalShell
      title="Customize Widgets"
      subtitle="Tick the blocks you want on your dashboard — your view is remembered"
      onClose={onClose}
      footer={footer}
      bodyClassName={styles.body}
    >
      {toggleable.map(renderItem)}
    </ModalShell>
  );
}
